import { useState } from 'react';

interface UrlDisplayProps {
  collectionName: string;
  requestName: string;
  onCollectionChange: (name: string) => void;
  onRequestChange: (name: string) => void;
}

export default function UrlDisplay({ 
  collectionName, 
  requestName, 
  onCollectionChange, 
  onRequestChange 
}: UrlDisplayProps) {
  const [isEditingCollection, setIsEditingCollection] = useState(false);
  const [isEditingRequest, setIsEditingRequest] = useState(false);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [, setContextMenuPosition] = useState({ x: 0, y: 0 });
  const [showCopiedFeedback,] = useState(false);

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setContextMenuPosition({ x: e.clientX, y: e.clientY });
    setShowContextMenu(true);
  };

  const handleClickOutside = () => {
    setShowContextMenu(false);
  };

  return (
    <div className="relative">
      <div 
        className="flex items-center bg-white rounded-lg transition-colors cursor-pointer"
        onClick={handleContextMenu}
      >
        {/* URL Path */}
        <div className="flex items-center flex-1">
          {isEditingCollection ? (
            <input
              type="text"
              value={collectionName}
              onChange={(e) => onCollectionChange(e.target.value)}
              onBlur={() => setIsEditingCollection(false)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') setIsEditingCollection(false);
                if (e.key === 'Escape') setIsEditingCollection(false);
              }}
              className="bg-blue-100 border border-blue-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500"
              autoFocus
            />
          ) : (
            <span 
              className="text-gray-500 text-sm cursor-text hover:text-gray-700 transition-all duration-150 px-2 py-1 rounded"
              style={{
                borderRadius: '4px',
                backgroundColor: 'transparent',
                color: 'rgb(33, 33, 33)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgb(237, 237, 237)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
              onClick={(e) => {
                e.stopPropagation();
                setIsEditingCollection(true);
              }}
            >
              {collectionName || 'collection'}
            </span>
          )}
          
          <span className="text-gray-400">/</span>
          
          {isEditingRequest ? (
            <input
              type="text"
              value={requestName}
              onChange={(e) => onRequestChange(e.target.value)}
              onBlur={() => setIsEditingRequest(false)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') setIsEditingRequest(false);
                if (e.key === 'Escape') setIsEditingRequest(false);
              }}
              className="bg-blue-100 border border-blue-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500"
              autoFocus
            />
          ) : (
            <span 
              className="text-gray-900 font-medium text-sm cursor-pointer hover:text-gray-700 transition-all duration-150 px-1 py-1 rounded"
              style={{
                borderRadius: '4px',
                backgroundColor: 'transparent',
                color: 'rgb(33, 33, 33)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgb(237, 237, 237)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
              onClick={(e) => {
                e.stopPropagation();
                setIsEditingRequest(true);
              }}
            >
              {requestName || 'request'}
            </span>
          )}
        </div>
        {/* Copy Icon with Tooltip */}
        <div className="relative ml-1 group">
          {/* <button
            onClick={(e) => {
              e.stopPropagation();
              copyLink();
            }}
            className={`flex items-center justify-center p-1 border border-gray-300 rounded transition-colors cursor-pointer ${
              showCopiedFeedback 
                ? 'text-green-500' 
                : 'text-gray-400 hover:text-gray-600'
            }`}
            style={{ minWidth: '20px', minHeight: '20px' }}
            title="Copy URL"
          >
            <svg 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </button> */}
          
          {/* Tooltip */}
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-30">
            {showCopiedFeedback ? 'Copied!' : 'Copy URL'}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
          </div>
        </div>
      </div>

      {/* Context Menu */}
      {showContextMenu && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={handleClickOutside}
          />
        </>
      )}
    </div>
  );
}
